export default "__VITE_ASSET__Cj$iJ2wb__"